import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@nobia/zeus-components/lib/icons'
import settings from '@nobia/zeus-components/lib/settings'
import styled from 'styled-components'

const Container = styled.div`
  border-radius: ${settings.brand === 'magnet' ? '13px' : '30px'};
  width: 49px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${p =>
    !p.enabled
      ? settings.brand === 'magnet'
        ? p.theme.base.newDST?.toggleOffTrack
        : p.theme.colors.darkGrey
      : settings.brand === 'magnet'
        ? p.theme.base.newDST?.statusOnline
        : p.theme.colors.green};
  transition: background-color 300ms ease;
  cursor: pointer;
`
const ControlIcon = styled(Icon)`
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-left: 3px;
  transition: transform 300ms ease;
  transform: ${({ enabled }) =>
    enabled ? 'translateX(0)' : 'translateX(145%)'};
  visibility: ${p => !!p.hide && 'hidden'};
`

const Control = styled.div`
  flex-shrink: 0;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  margin-right: 3px;
  border-radius: ${settings.brand === 'magnet' ? '12px' : '50%'};
  border: 1px solid ${p => {
    if (settings.brand === 'magnet')
      return p.theme.base.newDST?.visibilityToggleKnobBorder
    if (!p.enabled) return '#b3b6c0'
    return '#559f54'
  }};
  transition: transform 300ms ease;
  transform: ${({ enabled }) =>
    enabled ? 'translateX(0)' : 'translateX(-115%)'};
`

const Slider = ({ onEnable, onDisable, enabled, hideIcon, ...rest }) => (
  <Container
    enabled={enabled ? 1 : 0}
    onClick={() => (enabled ? onDisable() : onEnable())}
    {...rest}
  >
    <ControlIcon
      hide={hideIcon}
      enabled={enabled ? 1 : 0}
      type={enabled ? 'eye' : 'eye-disabled'}
      width={16}
      height={16}
    />
    <Control enabled={enabled ? 1 : 0} />
  </Container>
)

Slider.propTypes = {
  enabled: PropTypes.bool,
  hideIcon: PropTypes.bool,
  onEnable: PropTypes.func,
  onDisable: PropTypes.func,
}

Slider.defaultProps = {
  enabled: null,
  hideIcon: false,
  onEnable: PropTypes.func,
  onDisable: PropTypes.func,
}

export default Slider
